import React from "react";

class Dashboard extends React.Component {
  render() {
	 
    return (
		<React.Fragment>
	<h2>Dashboard</h2>
		</React.Fragment>
	);
  }
}

export default Dashboard;
